import { createFileRoute } from '@tanstack/react-router'

import { registerPublicFormsInterceptors } from '@/app/router/public-forms-interceptors'
import { PublicFormsLayout } from '@/widgets/layout'

export const Route = createFileRoute('/_public-forms')({
  beforeLoad: () => registerPublicFormsInterceptors(),
  component: RouteComponent,
})

export const PublicFormsRoute = Route

function RouteComponent() {
  return <PublicFormsLayout />
}
